<template>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'statistical',
  data(): DataInterface {
    return {
      href: {
        bd: 'https://hm.baidu.com/hm.js'
      },
      expand: {
        bd: 'acbf9546fa4d3d987796a35f0f5fde78'
      }
    };
  },
  watch: {
    $route: {
      handler(newData: any, oldDate: any): void {
        window._hmt && window._hmt.push([ '_trackPageview', this.$route.path ]);
      }
    }
  },
  mounted(): void {
    this.initBD();
  },
  methods: {
    //----- 百度 Start -----//
    /**
     * 初始化百度统计
     */
    async initBD(): Promise<any> {
      if (this.href.bd === '' || this.expand.bd === '') return;
      
      await $FN.File.load(`${ this.href.bd }?${ this.expand.bd }`)
        .then((response: any) => {
          console.log('统计-百度-加载完成：_hmt', window._hmt);
        });
    }
    //----- 百度 End -----//
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';
</style>